import { useEffect, useState } from 'react'

import { StylePanelProps } from '@/lib/stylePanel'
import useResponsivePadding from '@/lib/useResponsivePadding'

import { PhnxSectiontitle } from '../../01-atoms/Sectiontitle/Sectiontitle'
import styles from './RelatedArticles.module.css'

export type RelatedArticlesProps = {
  title?: string
  subtitle?: string
  description?: React.ReactNode
  items: any
  button?: React.ReactNode
  layout?: 'primary' | 'secondary' | 'tertiary' | 'quaternary' | 'quinary' | 'insights' | 'podcasts'
  container?: boolean
} & StylePanelProps

export const PhnxRelatedArticles: React.FC<RelatedArticlesProps> = ({
  title = '',
  subtitle = '',
  description,
  items,
  button,
  layout = 'primary',
  padding,
  backgroundColor,
  textColor,
  container = false,
}) => {
  const paddingStyles = useResponsivePadding(padding)
  const style = {
    ...paddingStyles,
    backgroundColor,
    color: textColor,
  }

  const itemsCount = items && items[0] && items.length !== null ? items[0].length : 0
  const [itemSet, setItemSet] = useState<any[]>([])
  useEffect(() => {
    setItemSet(items)
  }, [items])

  let itemsClass = `${styles['articles']} ${styles[itemsCount === 2 ? 'halfwidth' : itemsCount === 3 ? 'twothirds' : '']}`

  return (
    <div style={style} className="stylepanel">
      {}
      <style jsx>{`
        stylepanel {
          ${paddingStyles}
        }
      `}</style>
      <div
        className={`${styles['relatedarticles']} ${styles[`layout-${layout}`]} ${container ? 'container' : ''}`}
      >
        <div className={styles['relatedarticles-header']}>
          <PhnxSectiontitle title={title} subtitle={subtitle} variant={layout} />
          {/* {title && title !== '' && (
            <div className={styles.title} data-testid="title">
              <h2 className={layout === 'quaternary' ? 'title' : ''}>{title}</h2>
            </div>
          )}
          {subtitle && subtitle !== '' && (
            <div className={`subtitle ${styles.subtitle}`} data-testid="subtitle">
              {subtitle}
            </div>
          )} */}
          {description && description !== '' && (
            <div className={styles.description} data-testid="description">
              {description}
            </div>
          )}
          {layout === 'podcasts' && (
            <div className={styles.cta} data-testid="button">
              {button}
            </div>
          )}
        </div>
        <div className={`${itemsClass} ${layout === 'podcasts' ? 'podcasts' : ''}`}>{itemSet}</div>
        {/* if items are 0 then return */}
        {itemSet.length === 0 && <div>No items found</div>}
        {button && layout !== 'podcasts' && (
          <div className={styles.cta} data-testid="button">
            {button}
          </div>
        )}
      </div>
    </div>
  )
}
